exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".activity-editor.deleted {\n  opacity: 0.7;\n  padding: 5px;\n}\n", "", {"version":3,"sources":["/home/guille/chinespain/tripmaker-redux/src/app/activities/ActivityEditor.less","/home/guille/chinespain/tripmaker-redux/src/app/activities/ActivityEditor.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,aAAA;CCCD","file":"ActivityEditor.less","sourcesContent":[".activity-editor.deleted {\n  opacity: 0.7;\n  padding: 5px;\n}\n",".activity-editor.deleted {\n  opacity: 0.7;\n  padding: 5px;\n}\n"],"sourceRoot":""}]);

// exports
